// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"353":"b38d98f9","513":"25ee8d90","703":"b0b9fe48","787":"d109bacb","850":"3fa9bfe9"}[chunkId] + ".chunk.js";
};